import * as yup from "yup";

export const resetPasswordSchema = yup.object().shape({
  oldPassword: yup.string().trim().required("Required"),
  newPassword: yup
    .string()
    .trim()
    .required("Required")
    .min(8, "Password needs to be at least 8 characters long"),
});

export type ResetPasswordSchemaType = yup.InferType<typeof resetPasswordSchema>;
